export default "__VITE_ASSET__4ZxrKYDb__"